export const truncateDecimalNumber = (val, decimalPlaces = 2) => {
  if (!val) {
    return val;
  }

  const string = `${val}`;
  let [num, decimals = ''] = string.split('.');
  let final = num;

  if (decimals) {
    decimals =
      decimals.length > decimalPlaces
        ? decimals.substring(0, decimalPlaces)
        : decimals;

    final = `${final}.${decimals}`;
  }

  return final;
};

export const numericValueChecker = (value) => {
  let isNumeric = false;

  isNumeric = value || value === 0 ? true : false;

  if (isNumeric) {
    isNumeric = typeof value === 'number' ? true : false;
  }

  return isNumeric;
};

export const removeDecimals = (val) => {
  if (!val) {
    return val;
  }

  const string = `${val}`;
  let [num] = string.split('.');

  return num;
};

export const padZeroTen = (number) => {
  if (number < 10) {
    return `0${number}`;
  }

  return `${number}`;
};

export const createNumberOptions = (min = 1, max = 20, modifier) => {
  const options = [];

  for (let i = min; i <= max; i++) {
    const valuesFormatted = modifier
      ? modifier(i)
      : {
          label: `${i}`,
          value: i,
        };

    options.push(valuesFormatted);
  }

  return options;
};

export const setDecimals = (val, decimalPlaces = 2) => {
  if (!val) {
    return val;
  }

  return val.toFixed(decimalPlaces);
};
